import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.map');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'wiz-portal-kiosk-map',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.map/view.scss */
.select {
  border: 6px solid #FF6171;
  border-radius: 15px;
  width: 193px;
  height: 218px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.observatory {
  top: 11.7%;
  left: 9.2%;
}

.garden {
  top: 14.5%;
  left: 42.7%;
}

.arboretum {
  top: 19.4%;
  right: 9.3%;
}

.library {
  top: 34%;
  right: 51.5%;
}

.park {
  top: 34.7%;
  right: 18.6%;
}

.bridge {
  top: 49.8%;
  right: 22.9%;
}

.wiz-modal {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px;
  z-index: 4000;
}
.wiz-modal .modal {
  display: contents;
  width: 100%;
  max-width: 420px;
}
.wiz-modal .modal-content {
  width: 100%;
  min-width: 280px;
  max-width: 420px;
}`],
})
export class PortalKioskMapComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,@Inject( Router    )         private router: Router    ) { }

    public opt = '';
    public character = '';
    public modal = '';

    public async ngOnInit() {
        await this.service.init();
        this.modal = false;
        this.route.queryParams.subscribe(params => {
            this.character = params['character'];
        });
        await this.service.render();
    }

    public async select(opt) {
        if (this.opt == opt) {
            this.opt = '';
        } else {
            this.opt = opt;
        }
        await this.service.render();
    }

    public async start() {
        if (!this.opt) {
            this.modal = true;
            this.service.alert.error("장소를 선택해주세요");
        } else {
            this.router.navigate(
                ['/main/preparing'],
                { queryParams: { character: this.character, place: this.opt } }
            );
        }
    }
}

export default PortalKioskMapComponent;